import styled from 'styled-components';
import { Button } from '~/components/button';

export const FaqButton = styled(Button)`
  width: 40%;
  margin-bottom: 2rem;
  padding: 0.5rem;
  align-self: flex-start;
  display: none; // By default, the button is not displayed

  // Adjust according to your theme's media query for tablet landscape down
  ${props => props.theme.media.tabletLandscapeDown} {
    display: block; // Only show the button in this media query
  }
`;
